/**
 * @todo Удалить директорию полностью, если эксперимент не будет  удачным
 * @description Данный функционал появился в задаче CD-138414, будет удалён в задаче CD-138473
 */
import { ArticleHeading3, ArticleHeading5, Button, LinkButton } from '@cian/ui-kit';
import cn from 'classnames';
import * as React from 'react';

import * as styles from './ContractTemplateBlock.css';
import { IContractTemplateBlockViewProps } from './types';

export const ContractTemplateBlockView: React.VFC<IContractTemplateBlockViewProps> = props => {
  const { isUserAuthenticated, isMiniature, onClick } = props;

  const heading = isUserAuthenticated
    ? 'Скачайте шаблоны договоров и\u00a0актов приёма-\u2060передачи помещения'
    : 'Войдите, чтобы скачать шаблоны договоров и актов приёма-передачи помещения';

  const HeadingComponent = isMiniature ? ArticleHeading5 : ArticleHeading3;

  const renderButton = () => {
    if (isUserAuthenticated) {
      return (
        <LinkButton
          size="XS"
          download
          theme="fill_secondary"
          onClick={onClick}
          href={'https://cdn.cian.site/frontend/commercial-assets/documents/cian-dogovor-arendi.doc'}
        >
          Скачать
        </LinkButton>
      );
    }

    return (
      <Button size="XS" theme="fill_secondary" onClick={onClick}>
        Войти
      </Button>
    );
  };

  return (
    <div
      className={cn(styles['container'], {
        [styles['miniature']]: isMiniature,
      })}
    >
      <div className={styles['content']}>
        <HeadingComponent>{heading}</HeadingComponent>
        <div className={styles['button']}>{renderButton()}</div>
      </div>

      <div className={styles['image']}></div>
    </div>
  );
};

ContractTemplateBlockView.displayName = 'ContractTemplateBlockView';
